import config from "../../config";

// Exact cookie name for this environment; the API appends its environment outside production.
export const CSRF_COOKIE_NAME = config.csrfCookieName;

export const CSRF_HEADER_NAME = "X-CSRF-Token" as const;
